/** Sidebar count for the e-Sign menu (FR-REQ-04 badges): to act (Inbox) and returned (Sent). */
import { useAuth } from '../../../lib/auth';
import { useEsignSummary } from './api';

export function EsignNavBadge({ kind, collapsed }: { kind: 'action' | 'returned'; collapsed?: boolean }) {
  const { user } = useAuth();
  const s = useEsignSummary(!!user?.org);
  const n = s.data?.[kind] ?? 0;
  if (!n) return null;
  const label = kind === 'action' ? `${n} waiting for you` : `${n} returned to you`;
  return collapsed ? (
    <span aria-label={label} className="absolute right-1.5 top-1.5 h-2.5 w-2.5 rounded-full bg-brand" />
  ) : (
    <span aria-label={label} className="tabular ml-auto rounded-full bg-brand px-2 text-xs font-semibold leading-5 text-brand-ink">{n}</span>
  );
}
